document.addEventListener("DOMContentLoaded", function() {
  // Encuentra el h1 que contiene el span
  const collectionTitle = document.querySelector('.collection-hero__title span');
  
  if (collectionTitle) {
    // Elimina el contenido del span
    collectionTitle.remove();
  }
});

